import React, { FC } from 'react';
import { CustomButton, CustomModal } from 'components';
import { VoidFn } from 'types/baseTypes';
import { RedStrokeInfoIcon } from 'assets/icons';

interface InvalidInvoiceTotalModalProps {
  open: boolean;
  onClose: VoidFn;
  totalPaid: number;
  minimumTotal: number;
}

const InvalidInvoiceTotalModal: FC<InvalidInvoiceTotalModalProps> = ({ open, onClose, totalPaid, minimumTotal }) => {
  const handleGotItClick = (): void => {
    onClose();
  };

  return (
    <CustomModal open={open} closeModal={onClose} className="!w-[400px] !max-w-[400px]" enableOutsideClick={true}>
      <div className="flex flex-col items-center p-6">
        <div className="mb-6">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#F7C0C080]">
            <RedStrokeInfoIcon className="h-[31px] w-[31px] rotate-180" />
          </div>
        </div>

        <h2 className="mb-6 text-[17px] font-semibold text-primaryText">Invalid Invoice Total</h2>
        <p className="mb-4 text-center text-sbase text-primaryText">
          The total can't be less than the amount already paid.
        </p>

        <div className="mb-6 text-center text-sbase">
          <p className="text-primaryText">
            Your customer has already paid <span className="font-semibold">${totalPaid.toLocaleString()}</span>
          </p>
          <p className="mt-1 text-primaryText">
            Please keep the total at or above <span className="font-semibold">${minimumTotal.toLocaleString()}</span>.
          </p>
        </div>

        <CustomButton id="invalid-total-modal-got-it-button" onClick={handleGotItClick} className="w-full">
          Got it
        </CustomButton>
      </div>
    </CustomModal>
  );
};

export default InvalidInvoiceTotalModal;
